export const passEntry = () => {
  const allPassEntries = document.querySelectorAll('[js-pass-entry]');

  const canUseShare = navigator.canShare && navigator.canShare({ url: 'canShare' });
  const canCopyClipboard = typeof navigator !== 'undefined' && typeof navigator.clipboard !== 'undefined';
  const hidden = 'hidden';

  allPassEntries.forEach((pass) => {
    const passItem = pass.querySelector('[js-pass-entry-share]') as HTMLButtonElement;
    const copiedElement = pass.querySelector('[js-pass-entry-share-copied]') as HTMLElement;

    passItem.addEventListener('click', (e) => {
      e.preventDefault();

      const url = passItem.getAttribute('js-pass-entry-share-url');
      const text = passItem.getAttribute('js-pass-entry-share-text');
      const title = passItem.getAttribute('js-pass-entry-share-title');

      if (url && text && title) {
        if (canUseShare) {
          navigator.share({
            title,
            text,
            url
          });
        } else if (canCopyClipboard) {
          navigator.clipboard.writeText(url).then(() => {
            if (copiedElement) {
              copiedElement.classList.remove(hidden);
              setTimeout(() => {
                copiedElement.classList.add(hidden);
              }, 5000);
            }
          });
        } else {
          passItem.classList.add(hidden);
        }
      } else {
        passItem.classList.add(hidden);
      }
    });
  });
};
